<template>
  <div
    :class="`
      workbench-sequence-waggon-add
      mr-1 ml-1
      t-rounded
      t-shadow
      font-weight-light
      ${$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'}
    `"
    :style="`height: ${height}; top: calc(100% - ${height})`"
    >
    <div class="workbench-sequence-waggon-add-activator">
      <slot name="activator"/>
    </div>
    <div class="workbench-sequence-waggon-add-content">
      <slot name="content"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['height'],
    data: () => ({
    }),
  }
</script>
<style>
  .workbench-sequence-waggon-add {
    position: absolute;
    width: calc(100% - 8px);
    padding: 3px;
  }
  .workbench-sequence-waggon-add-activator {
    position: absolute;
    left: 50%;
    z-index: 20;
  }
  .workbench-sequence-waggon-add-content {
    display: flex;
  }
</style>
